<!-- <div class="loading">
	<h4>Loading app...</h4>
</div> -->

<div *ngIf="isLoading" class="loading-overlay">
	<div class="spinner"></div>
</div>
